import "./Map.html";
import "./Map.scss";

import type { IControllerConstructor, Injectable } from "angular";
import { module } from "angular";
import MapComponentController from "./MapComponentController";

export class MapComponent implements ng.IComponentOptions {
    public bindings: any;

    public controller: Injectable<IControllerConstructor>;

    public templateUrl: string;

    public transclude: boolean;

    constructor() {
        this.bindings = {
            siteId: "<",
        };
        this.controller = MapComponentController;
        this.templateUrl = "/App/Components/Site/Overview/Map/Map.html";
    }
}

module("mmManagePortal").component("mmSiteMap", new MapComponent());
